// DialogInvoiceCreditActual Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import currency from '../../../lib/currency.jsx'
import Dialog from '../../../common/layout/dialog/dialog.jsx'
import Checkbox from '../../../common/form/checkbox/checkbox.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'

class DialogInvoiceCreditActual extends Component {
  constructor (props) {
    super(props)

    this.state = {
      invoice: null,
      active: false,
      creditType: 'doNotInvoiceAgain'
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null
    }
  }

  show (invoice) {
    FabButtonManager.setVisible(false)
    this.setState({ active: true, invoice })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      creditType: 'doNotInvoiceAgain',
      invoice: null
    })
  }

  isActive () {
    return this.state.active
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = (ev) => {
    if (this.state.active && ev.keyCode === 13) {
      this._onFormSubmit(ev)
    }
  };

  render () {
    const { active } = this.state

    return (
      <Dialog
        active={active}
        onClose={this.hide.bind(this)}
        className='dialog-invoicecredit'
      >
        <div className='dialog-form'>
          <div className='dialogform-header'>
            <div className='title'>
              <IntlMessage ident='invoice.form.editInvoiceCreditHeader' />
            </div>
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className='forminfo'>
                      <IntlMessage ident='invoice.form.creditInfo' />
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Checkbox
                          checked={this.state.creditType === 'invoiceAgain'}
                          icon='radio'
                          onChange={this._onChangeType.bind(
                            this,
                            'invoiceAgain'
                          )}
                          onRenderLabel={this._renderCheckboxLabel.bind(
                            this,
                            'invoiceAgain'
                          )}
                        />
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Checkbox
                          checked={
                            this.state.creditType === 'doNotInvoiceAgain'
                          }
                          icon='radio'
                          onChange={this._onChangeType.bind(
                            this,
                            'doNotInvoiceAgain'
                          )}
                          onRenderLabel={this._renderCheckboxLabel.bind(
                            this,
                            'doNotInvoiceAgain'
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div className='dialogform-footer'>
              <div className='formrow'>
                <div className='formcol'>
                  <div className='totalinfo'>
                    <span className='title'>
                      <IntlMessage ident='invoice.form.creditInfoTotal' />
                    </span>
                    <div className='content'>
                      <h2 className='infovalue'>
                        {this.state.invoice
                          ? currency.formatSymbol(this.state.invoice.total)
                          : '-'}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              title='invoice.form.creditInvoiceSave'
              canHover={false}
              onClick={this._onFormSubmit.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  // Event handlers
  _onChangeType (value) {
    this.setState({ creditType: value })
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }

  _onFormSubmit () {
    const canInvoiceAgain = this.state.creditType === 'invoiceAgain'
    this.props.onSubmit(this.state.invoice, canInvoiceAgain)
  }

  _renderCheckboxLabel (type) {
    if (type === 'invoiceAgain') {
      return (
        <span className='creditoption'>
          <span className='title'>
            <IntlMessage ident='invoice.form.creditOptionTitleInvoiceAgain' />
          </span>
          <span className='info'>
            <IntlMessage ident='invoice.form.creditOptionInfoInvoiceAgain' />
          </span>
        </span>
      )
    }

    return (
      <span className='creditoption'>
        <span className='title'>
          <IntlMessage ident='invoice.form.creditOptionTitleDonotInvoiceAgain' />
        </span>
        <span className='info'>
          <IntlMessage ident='invoice.form.creditOptionInfoDonotInvoiceAgain' />
        </span>
      </span>
    )
  }
}

export default DialogInvoiceCreditActual
